export let ContactsExport;
(function (_ContactsExport) {
  let Status = /*#__PURE__*/function (Status) {
    Status["NEW"] = "new";
    Status["DONE"] = "done";
    Status["FAILED"] = "failed";
    return Status;
  }({});
  _ContactsExport.Status = Status;
})(ContactsExport || (ContactsExport = {}));